/**
 * DUNAMIS WEAR — Header
 */
(function () {
  'use strict';

  if (window.__dunamisHeaderInit) return;
  window.__dunamisHeaderInit = true;

  const theme = window.theme || {};
  const header = document.getElementById('site-header');

  if (header && header.classList.contains('site-header--transparent') && header.classList.contains('site-header--sticky')) {
    const isHome = document.body.classList.contains('template-index');

    function onScroll() {
      // Home: header não fica fixo — some ao descer (desktop e mobile)
      if (isHome) {
        header.classList.remove('site-header--scrolled');
        return;
      }
      header.classList.toggle('site-header--scrolled', window.scrollY > 50);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function setMobileNavOpen(open) {
    const mobileNav = document.getElementById('MobileNav');
    const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
    if (!mobileNav) return;

    mobileNav.classList.toggle('is-open', open);
    if (menuToggle) menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  function closeMobileNav() {
    setMobileNavOpen(false);
  }

  /* Event delegation — funciona em todas as páginas e após re-render */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-menu-toggle]')) {
      e.preventDefault();
      const mobileNav = document.getElementById('MobileNav');
      if (!mobileNav) return;
      setMobileNavOpen(!mobileNav.classList.contains('is-open'));
      return;
    }

    if (e.target.closest('[data-mobile-nav-close]')) {
      closeMobileNav();
      return;
    }

    if (e.target.closest('.mobile-nav__link')) {
      closeMobileNav();
      return;
    }

    if (e.target.closest('[data-search-toggle]') || e.target.closest('[data-cart-toggle]')) {
      closeMobileNav();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMobileNav();
  });

  /* Announcement bar rotation */
  const announcement = document.querySelector('[data-announcement-rotate]');
  if (announcement) {
    const messages = announcement.querySelectorAll('.announcement-bar__message');
    const interval = parseInt(announcement.dataset.interval, 10) || 5000;
    if (messages.length > 1) {
      let current = 0;
      setInterval(function () {
        messages[current].classList.remove('is-active');
        current = (current + 1) % messages.length;
        messages[current].classList.add('is-active');
      }, interval);
    }
  }

  /* Shipping CEP helper */
  document.querySelector('[data-shipping-calc]')?.addEventListener('click', function () {
    const cepInput = document.querySelector('[data-shipping-cep]');
    const results = document.querySelector('[data-shipping-results]');
    if (!results) return;

    const cep = (cepInput?.value || '').replace(/\D/g, '');
    if (cep.length !== 8) {
      results.innerHTML = '<p class="text-muted">Informe um CEP válido com 8 dígitos.</p>';
      return;
    }

    const threshold = window.theme?.freeShippingThreshold ? Math.round(window.theme.freeShippingThreshold / 100) : 299;
    results.innerHTML =
      '<p><strong>Frete calculado no checkout.</strong></p>' +
      '<p class="text-muted">Informe o CEP <strong>' + cepInput.value + '</strong> na etapa de entrega para ver PAC, SEDEX e demais opções via Frenet.</p>' +
      '<p class="text-muted">Frete grátis em compras acima de R$ ' + threshold + '.</p>';
  });
})();
